<div class="detail-modal">
  <div class="detail-modal__header">
    <div>
      <div class="detail-modal__title">DETALLE DE SOLICITUD</div>
      <div class="detail-modal__subtitle">{{ data.request.folio }}</div>
    </div>

    <button mat-icon-button mat-dialog-close aria-label="Cerrar detalle">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="detail-modal__content">
    <div *ngIf="data.payload; else emptyDetail">
      <div class="detail-section">
        <div class="detail-title">SOLICITUD</div>
        <div class="detail-grid">
          <div><strong>TIPO:</strong> {{ data.request.tipoSolicitud }}</div>
          <div><strong>ESTATUS:</strong> {{ data.request.estatus }}</div>
          <div><strong>EMAIL:</strong> {{ data.request.email }}</div>
          <div><strong>TELEFONO:</strong> {{ data.request.telefono || 'N/D' }}</div>
          <div><strong>CREADA:</strong> {{ data.request.fechaCreacionUtc | date:'yyyy-MM-dd HH:mm' }}</div>
        </div>
      </div>

      <div class="detail-section" *ngIf="data.payload.usuario">
        <div class="detail-title">USUARIO</div>
        <div class="detail-grid">
          <div><strong>USUARIO:</strong> {{ data.payload.usuario.usr }}</div>
          <div><strong>NOMBRE:</strong> {{ data.payload.usuario.nombres }} {{ data.payload.usuario.primerApellido }} {{ data.payload.usuario.segundoApellido }}</div>
          <div><strong>EMAIL:</strong> {{ data.payload.usuario.email }}</div>
          <div><strong>MOVIL:</strong> {{ data.payload.usuario.movil || 'N/D' }}</div>
          <div class="full-row"><strong>DOMICILIO:</strong> {{ data.payload.usuario.domicilio }}</div>
          <div><strong>ID ASENTAMIENTO:</strong> {{ data.payload.usuario.idAsentamiento }}</div>
        </div>
      </div>

      <div class="detail-section" *ngIf="data.payload.sucursal">
        <div class="detail-title">SUCURSAL</div>
        <div class="detail-grid">
          <div><strong>NOMBRE:</strong> {{ data.payload.sucursal.nombre }}</div>
          <div><strong>REGISTRO SANITARIO:</strong> {{ data.payload.sucursal.registroSanitario || 'N/D' }}</div>
          <div><strong>RESPONSABLE:</strong> {{ data.payload.sucursal.responsable }}</div>
          <div><strong>MATRICULA:</strong> {{ data.payload.sucursal.cedulaResponsable || 'N/D' }}</div>
          <div><strong>EMAIL:</strong> {{ data.payload.sucursal.emailResponsable || 'N/D' }}</div>
          <div><strong>TELEFONO:</strong> {{ data.payload.sucursal.telefonoResponsable || 'N/D' }}</div>
          <div class="full-row"><strong>DOMICILIO:</strong> {{ data.payload.sucursal.domicilio }}</div>
        </div>
      </div>

      <div class="detail-section" *ngIf="data.payload.medico">
        <div class="detail-title">MEDICO</div>
        <div class="detail-grid">
          <div><strong>MATRICULA GENERAL:</strong> {{ data.payload.medico.cedulaGeneral }}</div>
          <div><strong>UNIVERSIDAD:</strong> {{ data.payload.medico.universidad }}</div>
          <div><strong>ESPECIALIDAD:</strong> {{ data.payload.medico.especialidad || 'N/D' }}</div>
          <div><strong>MATRICULA ESP.:</strong> {{ data.payload.medico.cedulaEspecialidad || 'N/D' }}</div>
          <div><strong>HORARIO:</strong> {{ data.payload.medico.horario }}</div>
          <div><strong>COLEGIADO:</strong> {{ colegiadoName }}</div>
        </div>

        <div class="colegiado-actions" *ngIf="isSpainRegion">
          <button
            mat-stroked-button
            color="primary"
            [disabled]="validatingColegiado || !canValidateColegiado"
            (click)="validateColegiado()">
            {{ validatingColegiado ? 'VALIDANDO...' : 'VALIDAR COLEGIADO' }}
          </button>
        </div>

        <div class="colegiado-result" *ngIf="colegiadoValidation">
          <div class="colegiado-result__header">
            <div class="asset-label">RESULTADO DE VALIDACION</div>
            <span class="status-chip" [ngClass]="colegiadoStatusClass">
              {{ colegiadoValidation.habilitado ? 'HABILITADO' : 'NO HABILITADO' }}
            </span>
          </div>

          <div class="detail-grid">
            <div><strong>COLEGIADO:</strong> {{ colegiadoName }}</div>
            <div><strong>HTTP STATUS:</strong> {{ colegiadoValidation.httpStatus || 'N/D' }}</div>
            <div class="full-row"><strong>MENSAJE:</strong> {{ colegiadoValidation.mensaje || 'N/D' }}</div>
            <div *ngIf="colegiadoValidation.resultCode"><strong>RESULT CODE:</strong> {{ colegiadoValidation.resultCode }}</div>
            <div *ngIf="colegiadoValidation.validUntil"><strong>VALID UNTIL:</strong> {{ colegiadoValidation.validUntil }}</div>
          </div>
        </div>
      </div>

      <div class="detail-section" *ngIf="data.payload.paciente">
        <div class="detail-title">PACIENTE</div>
        <div class="detail-grid">
          <div><strong>FECHA NACIMIENTO:</strong> {{ data.payload.paciente.fechaNacimiento || 'N/D' }}</div>
          <div><strong>GENERO:</strong> {{ data.payload.paciente.genero || 'N/D' }}</div>
          <div><strong>ENTIDAD NACIMIENTO:</strong> {{ data.payload.paciente.idEntidadNacimiento || 'N/D' }}</div>
          <div><strong>TIPO ID:</strong> {{ data.payload.paciente.idTipoIdentificacion || 'N/D' }}</div>
          <div><strong>NUMERO ID:</strong> {{ data.payload.paciente.numeroIdentificacion || 'N/D' }}</div>
        </div>
      </div>

      <div class="detail-section" *ngIf="imagePreviewUrl || signaturePreviewUrl">
        <div class="detail-title">ARCHIVOS</div>
        <div class="asset-grid">
          <div class="asset-card" *ngIf="imagePreviewUrl">
            <div class="asset-label">IMAGEN DE PERFIL</div>
            <img [src]="imagePreviewUrl" alt="Imagen de perfil" />
          </div>

          <div class="asset-card" *ngIf="signaturePreviewUrl">
            <div class="asset-label">FIRMA</div>
            <img [src]="signaturePreviewUrl" alt="Firma" />
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-stroked-button color="primary" mat-dialog-close>CERRAR</button>
  </mat-dialog-actions>
</div>

<ng-template #emptyDetail>
  <div class="empty-state">
    NO SE PUDO LEER EL PAYLOAD DE LA SOLICITUD.
  </div>
</ng-template>
